export enum CallTranscriptionStatus {
  InProgress = 1,
  Completed = 2,
  Failed = 3,
}